<template>
  <van-collapse v-model="activeName" accordion class="politicalparty">
    <van-collapse-item
      title="基层智治数字化平台"
      name="1"
      class="politicalparty-item"
      :class="{ 'politicalparty-item-check': activeName == '1' }"
    >
      <!-- <div class="info">
        “浙里兴村治社”数字化系统以共同富裕目标，协同基层治理网格化建设与平台迭代升级，坚持发展新时代“枫桥经验”，运用数字化技术、思维和认知，打造镇村联动、创先争优、多维评价的基层工作体系，加快变革型组织建设，提升基层干部变革创新能力，构建党建统领的村社整体智治新格局，驱动乡村各领域全方位变革。
      </div> -->
      <div class="info">
        “基层智治数字化平台”聚焦提升城乡社区现代化建设水平，坚持以事为线索、以人为核心，通过运用数字化思维、技术和认知，打造自上而下任务一贯到底、自下而上民情一键回应“双向业务闭环”，全流程、各方面融入，把村社干部“管理流”建在全量多维的“业务流”上，加快变革型组织建设，提升基层干部变革创新能力，构建镇村联动、创先争优、多维评价的基层工作体系，有效打通“最后一公里”，是基层治理系统连接贯通村社的重要应用。
      </div>
      <img
        :src="product_society_society_jczz"
        alt="基层智治数字化平台"
        class="politicalparty-img"
      />
      <div class="superiority">
        <div class="title">产品价值</div>
        <div
          class="superiority-item"
          v-for="(item, index) in advantageList.xcgf"
          :key="`politicalparty-item1-superiority${index + 1}`"
        >
          <img :src="product_society_superiority" alt="重要性标志" />
          <span>{{ item }}</span>
        </div>
      </div>
    </van-collapse-item>
    <van-collapse-item
      title="两新组织"
      name="2"
      class="politicalparty-item"
      :class="{ 'politicalparty-item-check': activeName == '2' }"
    >
      <div class="info">
        以组织和人员的体验感和满意度出发，聚焦两新工作难点，以算法数据为核心，打造“一库、两口、三端、多翼”的智慧体系架构，实现“一屏控，一数知”，基于“评估-反馈-改进-优化”的组织机制，不断实现流程的再造、制度的重塑和机制的优化，推动从信息化向智慧化跃迁。
      </div>
      <img
        :src="product_society_society_lxzz"
        alt="两新组织"
        class="politicalparty-img"
      />
      <div class="superiority">
        <div class="title">产品价值</div>
        <div
          class="superiority-item"
          v-for="(item, index) in advantageList.lxzz"
          :key="`politicalparty-item2-superiority${index + 1}`"
        >
          <img :src="product_society_superiority" alt="重要性标志" />
          <span>{{ item }}</span>
        </div>
      </div>
    </van-collapse-item>
    <van-collapse-item
      title="换届一件事"
      name="3"
      class="politicalparty-item"
      :class="{ 'politicalparty-item-check': activeName == '3' }"
    >
      <div class="info">
        聚焦换届工作的痛点、难点，借助大数据、智能算法，设有“云联审”、“云智选”、“云履职”、“云分析”四个模块。旨在把好代表人选“质量”关、选举过程“风险”关、代表履职“评价”关、数据分析“智能”关，推动换届工作全程全面高质量进行。
      </div>
      <img
        :src="product_society_society_hyyjs"
        alt="换届一件事"
        class="politicalparty-img"
      />
      <div class="superiority">
        <div class="title">产品价值</div>
        <div
          class="superiority-item"
          v-for="(item, index) in advantageList.hjyjs"
          :key="`politicalparty-item3-superiority${index + 1}`"
        >
          <img :src="product_society_superiority" alt="重要性标志" />
          <span>{{ item }}</span>
        </div>
      </div>
    </van-collapse-item>
  </van-collapse>
</template>
<script>
import product_society_society_xczs from "@/../static/img/product/product_society_society_xczs.svg";
import product_society_society_jczz from "@/../static/img/product/product_society_society_jczz.svg";
import product_society_society_lxzz from "@/../static/img/product/product_society_society_lxzz.svg";
import product_society_society_hyyjs from "@/../static/img/product/product_society_society_hyyjs.svg";
import product_society_superiority from "@/../static/img/product/product_society_superiority.png";
export default {
  data() {
    return {
      product_society_society_xczs,
      product_society_society_jczz,
      product_society_society_lxzz,
      product_society_society_hyyjs,
      product_society_superiority,
      activeName: "",
      advantageList: {
        xcgf: [
          "重塑乡村治理的“共同体”",
          "健全干事创业的“责任链”",
          "构建村社干部减负赋能的“过滤网”",
          "建立风险防控的“预警器”",
          "完善率先争先的“刻度尺”"
        ],
        lxzz: [
          "推动两项覆盖 从呆板向灵活转变",
          "推动服务模式由单边向互动转变",
          "推动组织生活由传统向现代转变",
          "推动两新工作由管理向服务转变",
          "推动两新预警由被动向主动转变"
        ],
        hjyjs: [
          "选举过程热力指数",
          "建立选举过程风险防范闭环管理机制",
          "构建基层党员群众参政议政活跃度反馈机制",
          "构建代表履职评价机制",
          "完善选举监督机制"
        ],
        zhxf: [
          "人/事全维度分析",
          "事的智能研判",
          "重点管控全掌握",
          "态势全局化",
          "一站式业务办理"
        ],
        syzl: [
          "以指数体系为核心，量化考评纠纷化解成效",
          "聚焦诉/调全过程，衔接覆盖矛盾生灭全周期",
          "深度结合智能算法，推动复杂业务流程提效增质",
          "构建预警防范体系，多维分析辅助决策指挥",
          "形成评-防-联-治-优的良好局势，推动源头治理责任落实"
        ]
      }
    };
  }
};
</script>
<style lang="less" scoped>
.politicalparty {
  width: 100%;
  /deep/.van-cell {
    height: 94px;
    font-size: 28px;
    color: #08204d;
    line-height: 94px;
    text-align: center;
  }
  /deep/ .van-cell__right-icon {
    display: none;
  }
  .politicalparty-item {
    padding: 0 64px;
    background: #ffffff;
    .info {
      font-size: 24px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
    }
  }
  .politicalparty-item-check {
    /deep/.van-cell__title::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 35%;
      width: 30%;
      height: 2px;
      background-color: blue;
    }
  }
  .politicalparty-img {
    width: 100%;
    margin: 44px 0;
  }
  .superiority {
    margin-bottom: 32px;
    .title {
      font-size: 26px;
      color: #08204d;
      line-height: 36px;
      margin-bottom: 24px;
      font-weight: 600;
    }
    .superiority-item {
      display: flex;
      font-size: 24px;
      color: #08204d;
      line-height: 32px;
      margin-bottom: 32px;
      > img {
        width: 32px;
        height: 32px;
        margin-right: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product/society/politicalparty.vue